import React, { Component } from 'react';
import styled from 'styled-components';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"

import LabelledSelect from '../../../../web/components/LabelledSelect';
import LabelledTextInput from '../../../../web/components/LabelledTextInput';
import LabelledTextInputToggle from '../../../../web/components/LabelledTextInputToggle';
import LabelledTextInputWithMap from '../../../../web/components/LabelledTextInputWithMap';
import Notice from '../../../../web/components/Notice';

const openIcon = '/images/redesign/icon-open.png';
const closedIcon = '/images/redesign/icon-closed.png';

const MapComponent = withGoogleMap(({
  lat,
  lng,
  draggable,
  onChildMouseUp,
}) => {
  return (
    <GoogleMap
      defaultZoom={15}
      center={{ lat, lng }}
      defaultOptions={{
        disableDefaultUI: true,
      }}
      draggable={draggable}
    >
      <Marker
        position={{ lat, lng }}
        draggable
        onMouseUp={onChildMouseUp}
      />
    </GoogleMap>
  );
});

class Map extends Component {
  constructor(props) {
    super(props);

    this.onChildMouseUp = this.onChildMouseUp.bind(this);

    this.state = {
      draggable: true,
    };
  } 

  onChildMouseUp(marker) {
    const { lat, lng } = marker.latLng;
    this.setState({
      draggable: false,
      lat: lat(),
      lng: lng(),
    }, () => {
      this.props.onLatLngChange({
        lat: this.state.lat,
        lng: this.state.lng,
      });
    });
  }

  render() {
    return <MapComponent
      onChildMouseUp={this.onChildMouseUp}
      draggable={this.state.draggable}
      {...this.props}
    />;
  }
}

class Contact extends Component {
  constructor(props) {
    super(props);

    this.onLatLngChange = this.onLatLngChange.bind(this);

    this.state = {
      fetched: false,
      lat: 0,
      lng: 0,
    };
  }

  componentDidMount() {
    /* eslint-disable-next-line */
		window.amplitude.getInstance().logEvent('Contact Next button Click');
  }

  onLatLngChange({ lat, lng }) {
    this.setState({ lat, lng }, () => {
      this.props.onChange('latlng')({
        lat: this.state.lat,
        lng: this.state.lng,
      });
    });
  }

  render() {
    if (this.props.data.confirming) {
      const combinedAddress = this.props.data.customAddress || [
        this.props.data.buildingName,
        this.props.data.shopNumber,
        this.props.data.floorLevel,
        this.props.data.street1,
        this.props.data.street2,
        this.props.data.suburb,
        this.props.data.state,
        this.props.data.postCode,
      ].filter(v => !!v).join(', ');

      if (!this.state.fetched) {
        this.setState({
          fetched: true,
        }, () => {
          if (!window.google || !window.google.maps) return;
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode(
            { address: combinedAddress },
            (results) => {
              if (!results[0]) return;
              if (!results[0].geometry) return;
              if (!results[0].geometry.location) return;
              if (!results[0].geometry.location.lat) return;
              if (!results[0].geometry.location.lng) return;
              const { lat, lng } = results[0].geometry.location;
              this.setState({
                lat: lat(),
                lng: lng(),
              }, () => {
                this.props.onChange('latlng')({
                  lat: this.state.lat,
                  lng: this.state.lng,
                });
              });
            }
          );
        });
      }

      return (
        <div style={{ backgroundColor: 'none', width: 965 }}>
          <div style={{ width: 965, margin: 25, paddingTop: 25, color: '#505d68' }}>
            What you entered...
          </div>
          <InputContainer>
            <Column width="965px">
              <LabelledTextInputToggle
                placeHolder={this.props.data.shopName}
                name='whatYouEntered'
                type="text"
                value={combinedAddress}
                onChange={(e) => {
                  this.props.onChange('customAddress')(e);
                }}
                onSubmit={() => {
                  if (!window.google || !window.google.maps) return;
                  const geocoder = new window.google.maps.Geocoder();
                  geocoder.geocode(
                    { address: combinedAddress },
                    (results) => {
                      if (!results[0]) return;
                      if (!results[0].geometry) return;
                      if (!results[0].geometry.location) return;
                      if (!results[0].geometry.location.lat) return;
                      if (!results[0].geometry.location.lng) return;
                      const { lat, lng } = results[0].geometry.location;
                      this.setState({
                        lat: lat(),
                        lng: lng(),
                      }, () => {
                        this.props.onChange('latlng')({
                          lat: this.state.lat,
                          lng: this.state.lng,
                        });
                      });
                    }
                  );
                  this.setState({
                    fetched: false,
                  });
                }}
              />
            </Column>
          </InputContainer>
          <div style={{ width: 965, margin: 25, paddingTop: 25, color: '#505d68' }}>
            What we found...
          </div>
          <InputContainer>
            <Column width="965px">
              {
                this.state.lat !== 0 && this.state.lng !== 0 ? (
                  <LabelledTextInputWithMap
                    placeHolder={this.props.data.shopName}
                    name='whatWeFound'
                    type="text"
                    value={combinedAddress}
                    onLatLngChange={this.onLatLngChange}
                    lat={this.state.lat}
                    lng={this.state.lng}
                    Map={Map}
                  />
                ) : null
              }
            </Column>
          </InputContainer>
        </div>
      );
    }

    const {
      storeDeliveryDetails,
      storeDeliveryDetails2,
      posSystemDetails,
      days,
    } = this.props.fields;

    return (
      <form style={{ backgroundColor: 'none', width: 965 }}>
        <div style={{ width: 965, margin: 25, paddingTop: 25, color: '#505d68' }}>
          Please enter your store’s delivery details…
        </div>
        <InputContainer marginBottom="0px">
          {storeDeliveryDetails.map((field, key) => (
            <Column key={key}>
              <LabelledTextInput
                placeHolder={field.placeHolder}
                name={field.name}
                type="text"
                value={this.props.data[field.name]}
                onChange={this.props.onChange(field.name)}
              />
              { this.props.errors[field.name] ? (
                <div style={{ marginTop: 5 }}>
                  <Notice
                    color="red"
                    text={`Please enter a valid value`}
                    width="750"
                  />
                </div>
              ) : null }
            </Column>
          ))}
        </InputContainer>
        <InputContainer marginTop="0px">
          {storeDeliveryDetails2.map((field, key) => 
            field.name === 'state' ? (
              <LabelledSelect
                style={{ height: 45, width: 250 }}
                key={key}
                placeHolder={field.placeHolder}
                name={field.name}
                type="text"
                value={this.props.data[field.name]}
                onChange={this.props.onChange(field.name)}
                options={[
                  'NSW',
                  'WA',
                  'QLD',
                  'SA',
                  'VIC',
                  'TAS',
                  'ACT',
                  'NT',
                ]}
              />
            ) : (
              <Column width="300px" key={key}>
                <LabelledTextInput
                  width={250}
                  placeHolder={field.placeHolder}
                  name={field.name}
                  type="text"
                  value={this.props.data[field.name]}
                  onChange={this.props.onChange(field.name)}
                />
                { this.props.errors[field.name] ? (
                  <div style={{ marginTop: 5 }}>
                    <Notice
                      color="red"
                      text={`Please enter a valid value`}
                      width="750"
                    />
                  </div>
                ) : null }
              </Column>
            )
          )}
        </InputContainer>
        <div style={{ width: 965, margin: 25, paddingTop: 25, color: '#505d68' }}>
          And a few details about your store’s POS system…
        </div>
        <InputContainer>
          {posSystemDetails.map((field, key) => (
            <Column width="300px" key={key}>
              { field.name === 'xchangeit' ? (
                <LabelledSelect
                  style={{ height: 45 }}
                  key={key}
                  placeHolder={field.placeHolder}
                  name={field.name}
                  type="text"
                  value={this.props.data[field.name]}
                  onChange={this.props.onChange(field.name)}
                  options={[
                    'Yes',
                    'No',
                  ]}
                />
              ) : field.name === 'posSoftwareType' ? (
                <LabelledSelect
                  style={{ height: 45 }}
                  key={key}
                  placeHolder={field.placeHolder}
                  name={field.name}
                  type="text"
                  value={capitalizeFirstLetter(this.props.data[field.name])}
                  onChange={(e) => {
                    e.target.value = capitalizeFirstLetter(e.target.value);
                    this.props.onChange(field.name)(e);
                  }}
                  options={[
                    'Tower',
                    'POS',
                    'Access',
                    'Computerlink',
                    'Other',
                    'None',
                  ]}
                />
              ) : (
                <LabelledTextInput
                  width={250}
                  key={key}
                  placeHolder={field.placeHolder}
                  name={field.name}
                  type="text"
                  value={this.props.data[field.name]}
                  onChange={this.props.onChange(field.name)}
                />
              )}
              { this.props.errors[field.name] ? (
                <div style={{ marginTop: 5 }}>
                  <Notice
                    color="red"
                    text={`Please enter a valid value`}
                    width="750"
                  />
                </div>
              ) : null }
            </Column>
          ))}
          <Column width="300px" />
        </InputContainer>
        <div style={{ width: 965, margin: 25, paddingTop: 25, color: '#505d68' }}>
          Please confirm your store opening hours below…
        </div>
        <InputContainer>
          {days.map((day, key) => {
            const { open, from, to } = this.props.data[day.name];
            const options = [
              '12:00 am',
              '1:00 am',
              '2:00 am',
              '3:00 am',
              '4:00 am',
              '5:00 am',
              '6:00 am',
              '7:00 am',
              '8:00 am',
              '9:00 am',
              '10:00 am',
              '11:00 am',
              '12:00 pm',
              '1:00 pm',
              '2:00 pm',
              '3:00 pm',
              '4:00 pm',
              '5:00 pm',
              '6:00 pm',
              '7:00 pm',
              '8:00 pm',
              '9:00 pm',
              '10:00 pm',
              '11:00 pm',
            ];

            const fromOptions = options;
            const toOptions = options;

            return (
              <div style={{ backgroundColor: day.color, width: 965, height: 55, display: 'flex', flexDirection: 'row', borderRadius: 5, padding: 5, paddingLeft: 20, paddingRight: 20, justifyContent: 'space-between' }} key={key}>
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }} onClick={() => {
                  this.props.onChange(day.name)({
                    open: !open,
                    from: fromOptions[0],
                    to: toOptions[0],
                  });
                }}><div><Image src={open ? openIcon : closedIcon} /></div></div>
                <div style={{ width: 120, display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>{day.name}</div>
                <div style={{ width: 120, display: 'flex', justifyContent: 'center', flexDirection: 'column', color: '#505d68' }}>{open ? 'Open' : 'Closed'}</div>
                <div style={{ width: 170, display: 'flex', justifyContent: 'center', flexDirection: 'column', color: '#505d68' }}>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center '}}>From</div>
                    <div>
                      <select
                        style={{ width: 120, border: '1px solid #a2a2a2', height: 30, color: '#5d5d5d' }}
                        onChange={(e) => {
                          const { value } = e.target;
                          this.props.onChange(day.name)({
                            open: true,
                            from: value,
                            to: to || toOptions[0],
                          });
                        }}
                        value={this.props.data[day.name].from}
                      >
                        {fromOptions.map(opt => <option>{opt}</option>)}
                      </select>
                    </div>
                  </div>
                </div>
                <div style={{ width: 150, display: 'flex', justifyContent: 'center', flexDirection: 'column', color: '#505d68' }}>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center '}}>To</div>
                    <div>
                      <select
                        style={{ width: 120, border: '1px solid #a2a2a2', height: 30, color: '#5d5d5d' }}
                        onChange={(e) => {
                          const { value } = e.target;
                          this.props.onChange(day.name)({
                            open: true,
                            from: from || fromOptions[0],
                            to: value,
                          });
                        }}
                        value={this.props.data[day.name].to}
                      >
                        {toOptions.map(opt => <option>{opt}</option>)}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </InputContainer>
      </form>
    );
  }
}

export default withScriptjs(Contact);

const InputContainer = styled.div`
	display: flex;
	width: 946px;
	justify-content: space-between;
	margin: 24px;
  flex-wrap: wrap;
  margin-top: ${props => props.marginTop || '24px'}
  margin-bottom: ${props => props.marginBottom || '24px'}
`;

const Column = styled.div`
	width: ${props => props.width || '465px'};
	margin-bottom: 20px;
`;

const Image = styled.img`
	display: block;
	height: auto;
	width: 100%;
`;

function capitalizeFirstLetter(string) {
  if (string === 'pos') return 'POS';
  return string.charAt(0).toUpperCase() + string.slice(1);
}


// WEBPACK FOOTER //
// ./client/redesign/signup/Main/pages/Address/index.js